import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "@/components/vroom/confirm-dialog";

interface Below8hConfirmProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function Below8hConfirm({ open, onCancel, onConfirm }: Below8hConfirmProps) {
  const { t } = useTranslation();
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onCancel();
      }}
      title={t("admin.uren.below-8h-confirm.title")}
      description={t("admin.uren.below-8h-confirm.body")}
      // Annuleren is the PRIMARY (safe) button per the destructive-confirm convention
      safeLabel={t("admin.uren.below-8h-confirm.cancel")}
      onSafe={onCancel}
      destructiveLabel={t("admin.uren.below-8h-confirm.confirm")}
      onDestructive={onConfirm}
    />
  );
}
